import { type IUserCareerGoal } from '../../../models/userProfile';
import {
  baseInternalUser,
  coachCaseyProfile,
  leaderLeoProfile,
  newNoahProfile,
  veteranValProfile
} from '../fixtures/profile';
import { getScenario } from '../support/scenarios';
import { readStorage, storageKeys, writeStorage } from '../support/storage';

// --- Public Domain API ---

/**
 * Returns the mock internal user.
 */
export function getDevMockInternalUser() {
  const persona = getScenario('persona', 'mentee');
  if (persona === 'coach') {
    // WHY: Read from dedicated storage mapping if present to support persistent edits in coach view
    return readStorage(storageKeys.profileCoach, coachCaseyProfile);
  }
  if (persona === 'leader') {
    return readStorage(storageKeys.profileLeader, leaderLeoProfile);
  }
  if (persona === 'new') {
    return readStorage(storageKeys.profileNew, newNoahProfile);
  }
  if (persona === 'veteran') {
    return readStorage(storageKeys.profileVeteran, veteranValProfile);
  }
  return readStorage(storageKeys.profile, baseInternalUser);
}

/**
 * Updates the mock internal user.
 */
export function updateDevMockInternalUser(updates: {
  name?: string;
  title?: string;
  company?: string;
  linkedin?: string;
  email2?: string;
  careerGoals?: IUserCareerGoal | IUserCareerGoal[];
}) {
  const current = getDevMockInternalUser();
  const nextCareerGoals =
    updates.careerGoals === undefined
      ? current.careerGoals
      : Array.isArray(updates.careerGoals)
        ? updates.careerGoals
        : [updates.careerGoals];

  const persona = getScenario('persona', 'mentee');
  const keyMap: Record<string, string> = {
    coach: storageKeys.profileCoach,
    leader: storageKeys.profileLeader,
    new: storageKeys.profileNew,
    veteran: storageKeys.profileVeteran,
    mentee: storageKeys.profile
  };
  const key = keyMap[persona] || storageKeys.profile;

  // WHY: Writes back to the storage key associated with the active persona to maintain parity
  return writeStorage(key, {
    ...current,
    ...updates,
    careerGoals: nextCareerGoals
  });
}
